import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
	IQuestionnaireTemplateStateData,
	IQuestionnaireTemplateState,
} from 'src/features/questionnaire_template/domain/types';

import { QUESTIONNAIRE_TEMPLATE_LOADING_KEY } from './questionnaireTemplateThunks';

const initialState: IQuestionnaireTemplateState = {
	unsavedData: undefined,
};

export const questionnaireTemplateSlice = createSlice({
	name: QUESTIONNAIRE_TEMPLATE_LOADING_KEY,
	initialState,
	reducers: {
		setQuestionnaireUnsavedData: (
			state,
			action: PayloadAction<IQuestionnaireTemplateStateData>,
		) => {
			state.unsavedData = action.payload;
		},
		clearQuestionnaireUnsavedData: (state) => {
			state.unsavedData = undefined;
		},
	},
});

export const { setQuestionnaireUnsavedData, clearQuestionnaireUnsavedData } =
	questionnaireTemplateSlice.actions;
export default questionnaireTemplateSlice.reducer;
